import React from 'react';
import './App.css';
import StickyNavbar from './Components/Navbar/StickyNavbar';
// Use the correct name here
import HomePage from './Pages/Homepage/Homepage.js';
import CustomCursor from './Components/CustomCursor/CustomCursor.js';


function App() {
  return (
    <div className="App">
      <StickyNavbar />
      <main>
        <HomePage />
        <CustomCursor />
      </main>
    </div>
  );
}

export default App;
